
// @ts-nocheck
import locale__app_lang_es_json from "../lang/es.json";
import locale__app_lang_en_EN_json from "../lang/en-EN.json";
import locale__app_lang_de_DE_json from "../lang/de-DE.json";
import locale__app_lang_it_IT_json from "../lang/it-IT.json";
import locale__app_lang_fr_FR_json from "../lang/fr-FR.json";


export const localeCodes =  [
  "es",
  "en",
  "de",
  "it",
  "fr"
]

export const localeLoaders = {
  "es": [{ key: "../lang/es.json", load: () => Promise.resolve(locale__app_lang_es_json), cache: true }],
  "en": [{ key: "../lang/en-EN.json", load: () => Promise.resolve(locale__app_lang_en_EN_json), cache: true }],
  "de": [{ key: "../lang/de-DE.json", load: () => Promise.resolve(locale__app_lang_de_DE_json), cache: true }],
  "it": [{ key: "../lang/it-IT.json", load: () => Promise.resolve(locale__app_lang_it_IT_json), cache: true }],
  "fr": [{ key: "../lang/fr-FR.json", load: () => Promise.resolve(locale__app_lang_fr_FR_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "es",
      "country": "ES",
      "name": "Español",
      "files": [
        "/app/lang/es.json"
      ]
    },
    {
      "code": "en",
      "country": "GB",
      "name": "English",
      "files": [
        "/app/lang/en-EN.json"
      ]
    },
    {
      "code": "de",
      "country": "DE",
      "name": "Deutsch",
      "files": [
        "/app/lang/de-DE.json"
      ]
    },
    {
      "code": "it",
      "country": "IT",
      "name": "Italiano",
      "files": [
        "/app/lang/it-IT.json"
      ]
    },
    {
      "code": "fr",
      "country": "FR",
      "name": "Français",
      "files": [
        "/app/lang/fr-FR.json"
      ]
    }
  ],
  "defaultLocale": "es",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "root",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "es",
    "country": "ES",
    "name": "Español",
    "files": [
      {
        "path": "/app/lang/es.json"
      }
    ]
  },
  {
    "code": "en",
    "country": "GB",
    "name": "English",
    "files": [
      {
        "path": "/app/lang/en-EN.json"
      }
    ]
  },
  {
    "code": "de",
    "country": "DE",
    "name": "Deutsch",
    "files": [
      {
        "path": "/app/lang/de-DE.json"
      }
    ]
  },
  {
    "code": "it",
    "country": "IT",
    "name": "Italiano",
    "files": [
      {
        "path": "/app/lang/it-IT.json"
      }
    ]
  },
  {
    "code": "fr",
    "country": "FR",
    "name": "Français",
    "files": [
      {
        "path": "/app/lang/fr-FR.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
